<template>
    <div class="modal fade" id="reply-modal" tabindex="-1" role="dialog" aria-labelledby="replyModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="replyModalLabel" v-if="review.user">返信</h5>
                <h5 class="modal-title" id="replyModalLabel" v-else>返信を公開</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" v-if="review.id">
                <div class="text-right text-muted">
                    <ruby v-if="review.user">{{review.user.name}}<rt>{{review.user.kana}}</rt></ruby>
                    <div class="small">{{$filters.dateFormat(review.created_at)}}</div>
                </div>
                <div class="review" v-html="$filters.wrap(review.body)"></div>
                <h6 class="mt-4">返信</h6>
                <div class="text-pane">
                    <div class="text-pane-dummy">{{review.reply + '\u200b'}}</div>
                    <textarea class="text-pane-editor"
                        v-model="review.reply"
                        id="reply"
                        placeholder="返信"></textarea>
                </div>
                <div v-if="!review.user" class="my-4">
                    <span class="text-danger">匿名の読者からの感想のため、この感想に返信した場合、内容が一言欄に公開されます。</span>
                    投稿された一言を削除すると一言欄の返信は見えなくなりますが、感想と返信自体は削除されません。
                </div>
                <div v-else class="my-4">
                    登録ユーザーからの感想のため、この感想に返信した場合、登録ユーザーに直接返信が届きます。
                    感想と返信の内容は公開されません。
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
                <button type="button" class="btn btn-primary" @click="reply()" :disabled="!review.reply">返信を保存</button>
            </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.review {
    padding: 1rem;
    border-radius: .5rem;
}

.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        font-size: 1rem;
        line-height: 2rem;
        box-sizing: border-box;
        padding: .5rem 1rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: .5rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>

<script>
export default {
    props: {
        review_id: {
            default: null,
        }
    },
    data() {
        return {
            review: {},
        }
    },
    methods: {
        load() {
            axios.get("/mypage/review/get", {params: {id: this.review_id}}).then(res => {
                this.review = res.data;
            }).catch(err => {alert.err(err.response)});
        },
        reply() {
            axios.post("/mypage/review/reply", this.review).then(res => {
                alert.msg(res.data);
                $("#reply-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => {alert.err(err.response)});
        }
    },
    mounted() {
        $("#reply-modal").on("show.bs.modal", (e) => {
            this.load();
            setTimeout(() => {
                $("#reply").focus();
            }, 500);
        });
    }
}
</script>